/**
 * Falls back to same-origin when VITE_API_BASE_URL isn't set. Every deployed
 * environment (dev, staging, prod) already serves the frontend and API from
 * the same origin (see .env.production/.env.staging), so this keeps API
 * calls correct in local dev regardless of which port the dev server binds
 * to, instead of hardcoding one.
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || window.location.origin;
